export default __webpack_public_path__ + "static/media/google-play-badge-th.10dba935.png";